import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchInvitedUsers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/v1/companies/${queryParams.companyId}/invitations/non-active`, { params: queryParams.payload })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchUsers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/v1/companies/${queryParams.companyId}/users`, { params: queryParams.payload })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
